import { fixedTwoDigitsNumber } from "../components/Table/makeData";
import AmitDWHFundData from "../entities/AmitDWHFundData";
import FundDetails from "../entities/FundDetails";
import RedemptionRightData from "../entities/RedemptionRightData";
import SalaryData from "../entities/SalaryData";
import UserFund from "../entities/UserFund";
import { GetAmitRedemptionRights } from "./GetAmitRedemptionRights";
import { GetDepositData } from "./GetDepositData";
import { GetDWHStatusAmit } from "./GetDWHStatusAmit";
import { GetSalaryData } from "./GetSalaryData";
import { getFundCertificateNumber } from "../utils/helpers/getFundCertificateNumber";
import { PENSION_FUND_LABEL_AR, PENSION_FUND_LABEL_HE } from "../utils/constants/PensionConsts";

export const getUserFunds = async (userFundsData: FundDetails[]) => {
  let userFunds = [];
  let activeFunds: UserFund[] = [];
  let inActiveFunds: UserFund[] = [];
  let isAmitAndPensioner = false;
  let isAmit = false;
  let isPensioner = false;
  let haveMessages = false;

  userFunds = await Promise.all(
    userFundsData.map(async (fundData: FundDetails) => {
      // handle fund description and active fund for each case
      const fundDesc = () =>{
        return localStorage.getItem("lang") === "he" ? PENSION_FUND_LABEL_HE : PENSION_FUND_LABEL_AR
      }

      //boolean contortion:
      //const isActiveFund = !fundData.isAmit || await getAmitFundStatus(fundData.fundCode, userId);
      const isActiveFund = fundData.isAmit
        ? await getAmitFundStatus(fundData.fundCode)
        : true;

      const totalRedemption = fundData.isAmit
        ? await getAmitTotalRedemption(fundData.fundCode)
        : Infinity;

      // handle variable's indicates if user is amit and/or pensioner
      if (!isAmit && fundData.isAmit) isAmit = true;
      if (!isPensioner && fundData.isPensioner) isPensioner = true;

      // handle user amit and pensioner in same fund
      if (fundData.isAmit && fundData.isPensioner) {
        isAmitAndPensioner = true;
        const amitFund: UserFund = {
          // fundLabel: getFundLabel(parseInt(fundData.fundCode)),
          fundLabel: localStorage.getItem('lang') === "he" ? fundData.fundNameHeb: fundData.fundNameArabic,
          fundNameArab: fundData.fundNameArab,
          fundCertificateNumber: getFundCertificateNumber(
            parseInt(fundData.fundCode)
          ),
          fundDesc: fundDesc(),
          fundCode: fundData.fundCode,
          isAmit: fundData.isAmit,
          isPensioner: false,
          isActiveFund,
          totalRedemption,
        };
        const pensionerFund: UserFund = {
          // fundLabel: getFundLabel(parseInt(fundData.fundCode)),
          fundLabel: fundData.fundNameHeb,
          fundNameArab: fundData.fundNameArab,
          fundCertificateNumber: getFundCertificateNumber(
            parseInt(fundData.fundCode)
          ),
          fundDesc:fundDesc(),
          fundCode: fundData.fundCode,
          isAmit: false,
          isPensioner: fundData.isPensioner,
          isActiveFund: true,
          totalRedemption: Infinity,
        };

        activeFunds.push(pensionerFund);
        if (amitFund.isActiveFund) {
          activeFunds.push(amitFund);
        } else {
          inActiveFunds.push(amitFund);
        }

        return [amitFund, pensionerFund];
      }

      const fund: UserFund = {
        fundLabel: fundData.fundNameHeb,
        fundNameArab: fundData.fundNameArab,
        fundCertificateNumber: getFundCertificateNumber(
          parseInt(fundData.fundCode)
        ),
        fundDesc: fundDesc(),
        fundCode: fundData.fundCode,
        isAmit: fundData.isAmit,
        isPensioner: fundData.isPensioner,
        isActiveFund,
        totalRedemption,
      };

      // handle fund arrays by active fund
      if (isActiveFund) {
        activeFunds.push(fund);
      } else {
        inActiveFunds.push(fund);
      }

      return fund;
    })
  );

  if (isAmitAndPensioner) {
    // keep array of objects structure
    userFunds = userFunds.flat();
  }
  if (userFunds.length > 1) {
    // sort funds by totalRedemption
    activeFunds = activeFunds.sort((a: UserFund, b: UserFund) => {
      return b.totalRedemption - a.totalRedemption;
    });
    inActiveFunds = inActiveFunds.sort((a: UserFund, b: UserFund) => {
      return b.totalRedemption - a.totalRedemption;
    });
    // sort funds by active funds first
    userFunds = [...activeFunds, ...inActiveFunds];
  }

  // check for user messages
  if (isAmit) {
    const depositMessages = await GetDepositData(true);
    haveMessages = depositMessages?.length > 0;
  }

  return {
    userFunds,
    isAmit,
    isPensioner,
    haveMessages,
  };
}; //good

const getGimlaiFundDesc = async (fundCode: string) => {
  const salaryData = await GetSalaryData();

  return salaryData?.filter(
    (salary: SalaryData) => salary.fundCode === fundCode
  )[0].pensionTypeDesc;
};

const getAmitFundStatus = async (fundCode: string) => {
  const amitDWHFundsData = await GetDWHStatusAmit();

  const dwhFund: AmitDWHFundData = amitDWHFundsData?.filter(
    (dwhFund: AmitDWHFundData) => dwhFund.fundcode === fundCode
  )[0];

  return dwhFund?.insuranceStatus?.trim() === "פעיל";
};

const getAmitTotalRedemption = async (fundCode: string) => {
  const redemptionData = await GetAmitRedemptionRights();

  const redemption = redemptionData?.filter(
    (redemption: RedemptionRightData) =>
      redemption.fundCode === fundCode && redemption.isBalanceTypePension
  );
  if (redemption.length)
    return parseFloat(
      fixedTwoDigitsNumber(
        redemption[0].employeeSum +
          redemption[0].employerSum +
          redemption[0].compensationSum
      )
    );
  return 0;
};
